export default function workspaceProducerId(state: any) {
  return state.productFolderId;
}
